import React, { ChangeEvent, FC, useState } from 'react';
import { ReactComponent as CancelTripIcon } from 'assets/icons/cancel-trip-modal-icon.svg';
import { OrderType } from 'models/order.model';
import { toast } from 'react-toastify';
import { BaseModal, Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import { apiService } from 'utils/api';

interface RecallOrderModalProps {
  show: boolean;
  onClose: () => void;
  order: OrderType;
  kitchen?: boolean;
}

interface RecallOrderFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  disabled: boolean;
}

const RecallOrderFooter: FC<RecallOrderFooterProps> = ({
  onCancel,
  onConfirm,
  loading,
  disabled
}) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      disabled={disabled}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const RecallOrderModal: FC<RecallOrderModalProps> = ({ show, onClose, order, kitchen }) => {
  const [loading, setLoading] = useState(false);
  const [note, setNote] = useState('');
  const recallOrder = async () => {
    setLoading(true);
    try {
      kitchen
        ? await apiService.post(`kitchen/order/recall/${order.order_code}`, {
            baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
          })
        : await apiService.put(`cs/order/recall`, {
            data: {
              order_code: order.order_code,
              order_recalled_note: note
            }
          });
      toast(<ToastMessage type='success' message='Updated successfully' />);
      onClose();
    } catch (err: any) {
      onClose();

      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  const updateNote = (e: ChangeEvent<HTMLInputElement>) => {
    setNote(e.target.value);
  };
  return (
    <BaseModal
      isOpen={show}
      title='Recall Order'
      description={`Are you sure you want to recall this order #${
        order?.order_code?.toUpperCase() ?? ''
      }`}
      titleIcon={<CancelTripIcon />}
      titleIconColor='danger'
      onRequestClose={onClose}
      footer={
        <RecallOrderFooter
          loading={loading}
          onCancel={onClose}
          onConfirm={recallOrder}
          // disabled={note === ''}
          disabled={false}
        />
      }>
      {!kitchen && (
        <Input
          type='text'
          inputClass='py-2 text-sm'
          label='Order recall note'
          placeholder='Recall note'
          onChange={updateNote}
        />
      )}
    </BaseModal>
  );
};

export default RecallOrderModal;
